import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <path d="M 3 4 A 1.0001 1.0001 0 0 0 2 5 L 2 19 A 1.0001 1.0001 0 0 0 3 20 L 21 20 A 1.0001 1.0001 0 0 0 22 19 L 22 5 A 1.0001 1.0001 0 0 0 21 4 L 3 4 z M 4 6 L 20 6 L 20 18 L 18 18 L 18 16 L 13 16 L 13 18 L 4 18 L 4 6 z M 17.292969 8.2929688 L 13.802734 11.783203 L 10.447266 10.105469 A 1.0001 1.0001 0 0 0 9.2929688 10.292969 L 5.2929688 14.292969 L 6.7070312 15.707031 L 10.197266 12.216797 L 13.552734 13.894531 A 1.0001 1.0001 0 0 0 14.707031 13.707031 L 18.707031 9.7070312 L 17.292969 8.2929688 z" />,
  'BlackboardOutlined'
);
